<div class="w-full flex justify-center items-center" *ngIf="loading">
    <mat-spinner
        class="loading-spinner"
        [color]="color"
        [diameter]="diameter"
    >
    </mat-spinner>
</div>
<div class="w-full" *ngIf="!loading">
    <div class="flex justify-center">
        <h3 class="text-center"><b>Enter the OTP sent to your registered mobile number</b></h3>
    </div>
    <div class="row">
        <div class="offset-md-1 offset-lg-1 offset-xl-2 col-sm-12 col-md-10 col-lg-10 col-xl-8">
            <form>
                <mat-form-field appearance="standard" class="w-full mx-1 tile" appearance="none">
                    <mat-label>Enter One-Time Pin</mat-label>
                    <input
                    matInput
                    (click)="resetValidation()"
                    [formControl]="otp"
                    required
                    [errorStateMatcher]="matcher"
                    >
                    <mat-error *ngIf="showErrors">
                        Please enter {{(otpControl.value.name ? otpControl.value.name : 'a valid otp')| lowercase}}.
                    </mat-error>
                </mat-form-field>
            </form>
        </div>
    </div>
    <div class="payment-method-description-container flex justify-center items-center mt-2 w-full mb-8" *ngIf="!otpSubmitted">
        <div *ngIf="!otpLoading" class="flex items-center hpx-50 mb-3">
            <p class="md:text-lg lg:text-lg xl:text-md w-full text-center mt-3">
                Still waiting on your OTP?
            </p>
            <a target="_blank"
            mat-stroked-button class="overflow-hidden text-xs w-24 back-button justify-center items-center ml-2" (click)="resendOTP()">
            Resend
            </a>
        </div>
        <div class="m-4" *ngIf="otpLoading">
            <mat-spinner
            class="loading-spinner"
            >
            </mat-spinner>
        </div>
    
    </div>
    <div class="grid grid-cols-1 gap-4 justify-items-stretch">
        <button class="w-full md:w-4/12 justify-self-center continue" [ngStyle]="{'background-color':getColorScheme(), 'color':getTextColor()}" mat-raised-button (click)="enteredOTP()">Confirm</button>
    </div>
</div>


<!-- <div class="flex justify-center pt-4 pb-6">
    <h3 class="text-center"><b>Verifying your OTP...</b></h3>
</div>  
<div class="flex justify-center pt-4 pb-8">
    <mat-spinner></mat-spinner>
</div> -->